import React from 'react';

export const DocumentSvg: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={18}
      height={16}
      fill='none'
    >
      <path
        stroke='#6C6D84'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        d='M10.053 1.333H4.464c-.37 0-.726.14-.988.39s-.41.59-.41.944v10.666c0 .354.148.693.41.943s.617.39.988.39h8.384c.37 0 .726-.14.988-.39s.41-.59.41-.943v-8l-4.193-4ZM11.45 11.333H5.862M11.45 8.667H5.862M7.259 6H5.86'
      />
      <path
        stroke='#6C6D84'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        d='M10.053 1.333v4h4.192'
      />
    </svg>
  );
};
